<template>
    <div>
        <div v-for="(el,index) in value" :key="index" class="vrCom_1">
            <div class="vrCom_1_1">
                {{index+1}}号图
            </div> 
            <div class="vrCom_1_2">
                <span :class="index==0?'vrCom_1_2x':''" @click="qh2(index)">上移</span>
                <span :class="index==value.length-1?'vrCom_1_2x':''" @click="qh(index)">下移</span>
                <span :class="value.length==1?'vrCom_1_2x':''" @click="delt(index)">删除</span>
            </div>
            <div class="vrCom_1_3">
                <el-form-item label="点击区域" class="jump-link-group">
                    <el-input v-model="value[index].x" :placeholder="'X坐标'"></el-input>
                    <el-input v-model="value[index].y" :placeholder="'Y坐标'"></el-input>
                    <el-input v-model="value[index].width" :placeholder="'宽度'"></el-input>
                    <el-input v-model="value[index].height" :placeholder="'高度'"></el-input>          
               
                <!-- 跳转内容选择 -->
            
                </el-form-item>
                
                
            </div>
            <tz-fs v-model="value[index]"></tz-fs>
        </div>
        <div @click="addFn" class="vrCom_2">+ 添加展示图</div>
    </div>
  
</template>
<script>
import tzFs from "./tzFs.vue"

export default {
    components: {
        tzFs
    },
    props:{
        value:Array
    },


    methods: {
        qh2(on){
            if(on==0){
                return
            }
            this.value.splice(on-1,2,this.value[on],this.value[on-1]);
        },
        qh(on){
            if(on==this.value.length-1){
                return
            }
            this.value.splice(on,2,this.value[on+1],this.value[on]);
        },
        delt(on){
            if(this.value.length===1){
                return
            }
            this.value.splice(on,1);
        },
        addFn(){

            this.value.push({
               
                  jump_type:'1',
                  hd:{jump_type:'1'}
             
              })
        },
    },
};
</script>
<style lang='scss'>
.vrCom_1{
    position: relative;
    border: 1px solid #DCDFE6;
    padding:  10px;
    margin-bottom: 10px;
    border-radius: 5px;
}
.vrCom_1_2{
    position: absolute;
    right: 20px;
    top: 10px;
    line-height: 40px;
}
.vrCom_1_2>span{
    margin:0 5px;
    cursor: pointer;
    color: #33b3ff;
}
.vrCom_1_2>span.vrCom_1_2x{
    color: #c4c6d2;
}
.vrCom_1_3 .el-input{
    display: inline-block;
    vertical-align: top;
    width: 180px;
    margin-right: 10px;
}
.vrCom_1_3_1{
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
}
.vrCom_2:hover{
    color: #33b3ff;
}
.vrCom_2{
    border: 1px solid #DCDFE6;
    text-align: center;
    cursor: pointer;
}
</style>